import { IMG_ORGANIZER } from './competitionBranding';

interface SidebarBrandProps {
  sidebarOpen: boolean;
}

export const SidebarBrand = ({ sidebarOpen }: SidebarBrandProps) => (
  <div className="flex h-16 items-center justify-center border-b border-gray-200 px-4">
    <img
      src={IMG_ORGANIZER}
      alt="Organizator turnieju"
      className={sidebarOpen ? 'h-9 max-w-[140px] object-contain' : 'h-7 w-7 object-contain'}
    />
  </div>
);
